import { type FC } from "react";

import { Spinner } from "@snapchat/snap-design-system";

interface EmptyMessageProps {
    isLoading: boolean;
    message: string;
}

export const EmptyTableMessage: FC<EmptyMessageProps> = ({ isLoading, message }) => {
    return <div>{isLoading ? <Spinner /> : message}</div>;
};
